// Change membership billing level
import React, { useState, useEffect, useRef } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useApi } from "../../hooks/UseApi";

import Button from "../common/Button";
import ContributeNav from "../common/ContributeNav";
import FormActions from "../common/FormActions";
import FormErrors from "../common/FormErrors";
import GhostContentPage from "../common/GhostContentPage";
import LevelSelector from "../common/LevelSelector";
import Loader from "../common/Loader";
import MemberCenter from "../members/MemberCenter";
import Reason from "../common/Reason";
import Title from "../common/Title";

const ChangeIntro = () => {
  return (
    <div className="page-intro">
      <Title title="Change membership level" />
      <p>
        We rely on you for 30% of operating budget — increasing your level of
        support will have a direct impact on what we can do to further long-term
        thinking.
      </p>
    </div>
  );
};

const ChangeLevel = (props) => {
  const { put } = useApi(onError);
  const [formError, setFormError] = useState();
  const [formSuccess, setFormSuccess] = useState(false);
  useEffect(() => {
    if (props.member.good_standing == "false") {
      setFormError(
        "Your payment method is out of date. Update your billing settings before changing your level."
      );
      submit.current.disabled = true;
    }
  }, []);
  const loader = useRef(null);
  const submit = useRef(null);
  const methods = useForm({
    mode: "onBlur",
  });
  const { handleSubmit } = methods;
  const onSubmit = (formData) => {
    const getLevelName = props.levels.filter((obj) => {
      return obj.id === formData.membership_level;
    });
    const level = getLevelName[0].name;
    const frequency =
      level != "Equation of Time Cam" ? formData.cc_recurring : "YEAR";
    submit.current.disabled = true;
    loader.current.classList.add("show");
    const body = {
      level: level,
      frequency: frequency,
      upgrade_reason: formData.reason,
    };
    put(`membership/user/${props.member.username}/plan`, body, "csrf").then(
      (data) => {
        if (data) {
          setFormSuccess(true);
          localStorage.clear();
        }
      }
    );
  };
  function onError(formError) {
    props.loader.current.classList.remove("show");
    props.submit.current.disabled = false;
    setFormError("Something went wrong. Please try again later.");
  }
  if (formSuccess) {
    if (props.mode == "upgrade") {
      return (
        <div className="component-contribute">
          <div className="page-intro">
            <GhostContentPage slug={"upgrade-message"} />
            <Button action="memberCenter" />
          </div>
        </div>
      );
    } else {
      return (
        <MemberCenter
          member={props.member}
          status="success"
          message="Level changed successfully."
        />
      );
    }
  } else {
    const bottomLevel = props.mode == "upgrade" ? props.memberLevel : null;
    return (
      <div className="component-change-level">
        {props.mode == "upgrade" ? (
          <ContributeNav mode={props.mode} handleMode={props.handleMode} />
        ) : (
          <ChangeIntro />
        )}
        <div className="page-surface">
          <FormProvider {...methods}>
            <form
              id="Change_membership_level"
              onSubmit={handleSubmit(onSubmit)}
              noValidate
            >
              <div className="intro">
                <div className="intro-text">
                  {props.memberLevel != 0 && (
                    <h3>Choose a new membership level —</h3>
                  )}
                </div>
              </div>
              <LevelSelector
                levels={props.levels}
                initialLevel={props.memberLevel}
                bottomLevel={bottomLevel}
                legacyMember={props.member.legacy}
              >
                <Reason placeholder="What prompted you to change your membership level today? Optional, but we’re listening…" />
                {formError && <FormErrors message={formError} />}

                <FormActions>
                  <Button action="save" ref={submit} />
                  <Button action="cancel" />
                  <Loader ref={loader} />
                </FormActions>
              </LevelSelector>
            </form>
          </FormProvider>
        </div>
      </div>
    );
  }
};
export default ChangeLevel;
